__turbopack_context__.v({
  "innerRow": "KWM0oG_innerRow",
  "row": "KWM0oG_row",
  "spaceBetween": "KWM0oG_spaceBetween",
});
